import TreeItemFinder from "../../../layers/util/TreeItemFinder";
import TreeItemVisibilityHandler from "../../../layers/util/TreeItemVisibilityHandler";
import uuid from "uuid";
import { updateObject } from "../../../common/util/UpdateObject";
import Logger from "../../../common/util/Logger";
import { IPartialReducer } from "../../../core/core-redux/reduxTypes";
import { GeoCalcState } from "../../types";

const logger = new Logger();

export const setGeoCalculationVisibilityReducer: IPartialReducer<GeoCalcState> = (state, action) => {
    logger.info(`toggling geoCalculation '${action.geoCalculationId}' geometry visibility to '${action.visibility}`);

    const items = [...state.items];
    const item = TreeItemFinder.findItem(action.geoCalculationId, items);

    TreeItemVisibilityHandler.setTreeItemVisibility(item, action.visibility);

    const affectedItems = TreeItemFinder.getItemAndItsChildren(item);
    const ids = affectedItems.map((i) => i.id);
    const featureLayer = state.featureLayer;
    const textLayer = state.textLayer;

    if (textLayer && featureLayer) {
        featureLayer.features[0].features
            .filter((feat) => ids.includes(feat.calculationId))
            .forEach((feature) => (feature.properties!.style.hidden = !action.visibility));

        featureLayer.features[0].id = uuid();

        textLayer.features[0].features
            .filter((text) => ids.includes(text.calculationId))
            .forEach((text) => (text.properties!.style.hidden = !action.visibility));

        textLayer.features[0].id = uuid();
    }

    return updateObject(state, { items: items, featureLayer: featureLayer, textLayer: textLayer });
};
